import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { DropletIcon } from 'lucide-react';
import useTranslation from '@/hooks/use-translation';

const NotFound = () => {
  const { translate } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <DropletIcon className="h-16 w-16 mx-auto mb-6 text-primary animate-bounce" />
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <h2 className="text-2xl font-semibold mb-4">
          {translate("Page Not Found")}
        </h2>
        <p className="text-muted-foreground mb-8">
          {translate("The page you're looking for doesn't exist or has been moved.")}
        </p>
        <Button asChild>
          <Link to="/">
            {translate("Return Home")}
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
